export default __webpack_public_path__ + "static/media/edge.01a4ea8d.svg";